import { Component,  OnInit} from '@angular/core';


@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  mainMessage: string='Incorrect date or time detected.';
  errorMessage: string ='Please reset to the correct settings';

  constructor() { }

  ngOnInit(): void {

  }
}
 
